/* eslint-disable react/function-component-definition */
import React from 'react';
import Select from 'react-select';
import cn from 'classnames';
import SVG from 'react-inlinesvg';

import defaultStyles from './ReactSelect.module.postcss';

const ClearIcon = ({ size = 10 }) => (
  <SVG src='/static/images/admin/x-black.svg' height={size} width={size} />
);

const ClearIndicator = (props) => {
  const { children = <ClearIcon />, theme, innerProps: { ref, ...restInnerProps } } = props;
  return (
    <div
      {...restInnerProps}
      ref={ref}
      className={theme.ReactSelect_clearIndicator}
    >
      {children}
    </div>
  );
};

const MultiValueRemove = (props) => {
  const { children = <ClearIcon size='8' />, innerProps: { ref, ...restInnerProps } } = props;
  return (
    <div
      {...restInnerProps}
      ref={ref}
      className={restInnerProps.className}
    >
      {children}
    </div>
  );
};

function ReactSelect(props) {
  const { theme } = props;
  const styles = theme || defaultStyles;

  return (
    <Select
      {...props}
      components={{ ClearIndicator, MultiValueRemove }}
      classNames={{
        control: () => styles.ReactSelect_control,
        dropdownIndicator: () => styles.ReactSelect_dropdownIndicator,
        indicatorSeparator: () => styles.ReactSelect_indicatorSeparator,
        menu: () => styles.ReactSelect_menu,
        menuList: () => styles.ReactSelect_menuList,
        option: ({ isSelected }) => cn(
          styles.ReactSelect_option,
          isSelected && styles.ReactSelect_option_selected,
        ),
        placeholder: () => styles.ReactSelect_placeholder,
        valueContainer: () => styles.ReactSelect_valueContainer,
        clearIndicator: () => styles.ReactSelect_clearIndicator,
        multiValueLabel: () => styles.ReactSelect_multiValueLabel,
        multiValueRemove: () => styles.ReactSelect_multiValueRemove,
        singleValue: () => styles.ReactSelect_singleValue,
      }}
    />
  );
}

export default ReactSelect;
